import React from 'react';
import { useTranslation } from 'react-i18next';

import { SUPPORTED_LANGUAGES, LANGUAGE_SHORT_LABELS } from '../constants/languages';

export default function LanguageSwitcher({ className = '' }) {
  const { i18n, t } = useTranslation();

  function handleChange(event) {
    const nextLanguage = event.target.value;
    if (nextLanguage !== i18n.language) {
      i18n.changeLanguage(nextLanguage);
    }
  }

  return (
    <select
      aria-label={t('common.selectLanguage', 'Select language')}
      className={`custom-select custom-select-sm ${className}`.trim()}
      onChange={handleChange}
      value={i18n.language}
    >
      {SUPPORTED_LANGUAGES.map(code => (
        <option
          key={code}
          title={t(`languages.${code}`)}
          value={code}
        >
          {LANGUAGE_SHORT_LABELS[code] || code.toUpperCase()}
        </option>
      ))}
    </select>
  );
}

